import { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import cn from 'classnames';
import React from 'react';

export function makeOptions(className = 'style-body-m'): Options {
  return {
    renderNode: {
      [BLOCKS.UL_LIST]: (node, children) => <ul className="">{children}</ul>,
      [BLOCKS.LIST_ITEM]: (node, children) => {
        return (
          <li
            className={cn(
              'text-grey-80 dark:text-white flex flex-row',
              className,
            )}
          >
            <div className="mr-3">
              <span>&#8226;</span>
            </div>
            <div>
              {React.Children.map(children, (c) => {
                if (React.isValidElement(c) && c.type === 'p')
                  return c.props.children;
                return null;
              })}
            </div>
          </li>
        );
      },
      [BLOCKS.PARAGRAPH]: (node, children) => {
        if (React.Children.count(children) === 1 && children[0] === '')
          return null;
        return <p className="whitespace-pre-line">{children}</p>;
      },
    },
  };
}
